import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { CompanyForm } from '@/modules/companies/components/CompanyForm';
import { useCreateCompanyMutation } from '@/modules/companies/mutations/useCreateCompanyMutation';
import type { CompanyRequestApi } from '@/modules/companies/types';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/modules/ui/components/card/Card';
import Container from '@/modules/ui/components/container/Container';
import { PageHeader } from '@/modules/ui/components/page-header/PageHeader';
import { extractErrorMessage } from '@/utils/extractErrorMessage';

const CompanyAdd = () => {
  const navigate = useNavigate();
  const createCompanyMutation = useCreateCompanyMutation();

  const handleSubmit = async (values: CompanyRequestApi) => {
    createCompanyMutation.mutate(values, {
      onSuccess: () => {
        toast.success('Company has been added');
        navigate('/companies');
      },
      onError: (error) => {
        toast.error(
          `Company has not been added: ${extractErrorMessage(error)}`,
        );
      },
    });
  };

  return (
    <Container>
      <PageHeader title="Add Company" />
      <Card>
        <CardHeader>
          <CardTitle>Company details</CardTitle>
          <CardDescription>Basic information about the company</CardDescription>
        </CardHeader>
        <CardContent>
          <CompanyForm
            submitText="Add Company"
            isPending={createCompanyMutation.isPending}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/companies')}
          />
        </CardContent>
      </Card>
    </Container>
  );
};

export default CompanyAdd;
